var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-text-tag--container"},[_c('v-icon',{attrs:{"size":_vm.size,"color":_vm.color}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"body--2",style:({'color': _vm.color, 'font-weight': _vm.bold ? 'bold' : 'normal'})},[_vm._v(_vm._s(_vm.$t(_vm.text)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }